import dynamic from 'next/dynamic';
const PlanCard = dynamic(() => import('./PlanCard'));

export { PlanCard };
export { type PlanCardProps } from './PlanCard';
